<script lang="ts" setup></script>
<template>
<div class="banner banner--desktop-middle-center" style="min-height: 500px">
        <div class="banner__content" style="align-items: center!important;">
            <div class="banner__layout center-align">
                <h1 class="title-xl text-rothcoBlack">404</h1>
                <p class="paragraph-default text-rothcoBlack">The page you are looking for does not exist.</p>
            </div>
        </div>
</div>
</template>